{
  "internalPortal": {
    "components": {
      "subsidiaryOrganizations": {
        "title": "Subsidiary organizations",
        "actions": {
          "new": "New subsidiary org"
        },
        "noData": {
          "withoutFilters": {
            "title": "No subsidiaries linked to this organization",
            "description": "Create or link subsidiary organizations to {{organizationName}}"
          }
        },
        "deleteDialog": {
          "title_one": "Deleting subsidiary organization",
          "title_other": "Deleting subsidiary organizations",
          "description_one": "Are you sure you want to remove this subsidiary organization? It won't be possible to restore it.",
          "description_other": "Are you sure you want to remove {{count}} subsidiary organizations? It won't be possible to restore them."
        }
      }
    }
  }
}
